<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>
  <div class="main-panel">
    <header class="topbar">
      <h1>Notificaciones</h1>
      <div class="topbar-right">
        <app-header-notification-bell [rol]="rol"></app-header-notification-bell>
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>
    <app-actualizaciones-panel *ngIf="notificacionesDisponibles; else notificacionesNoDisponibles" [rol]="rol"></app-actualizaciones-panel>

    <ng-template #notificacionesNoDisponibles>
      <main class="content">
        <section class="access-card">
          <h2>Notificaciones no disponibles</h2>
          <p>Este m&oacute;dulo no aplica para el rol seleccionado.</p>
        </section>
      </main>
    </ng-template>
  </div>
</div>
